// src/App.js
import React from "react";
import LotteryPickerWithAutofill from "./components/LotteryPickerWithAutofill";

function App() {
  return (
    <div>
      <LotteryPickerWithAutofill />
    </div>
  );
}

export default App;
